import { render } from "./CustomDatePicker.vue?vue&type=template&id=4570e0a4&scoped=true"
import script from "./CustomDatePicker.vue?vue&type=script&lang=js"
export * from "./CustomDatePicker.vue?vue&type=script&lang=js"

import "./CustomDatePicker.vue?vue&type=style&index=0&id=4570e0a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4570e0a4"]])

export default __exports__